'use client'

import { WishlistItemListDS } from '@src/components/blocks/wishlist-item-list-ds'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { WishlistItem } from '../../wishlist.types'

import WishlistItemListLegacy from './wishlist-item-list-legacy'

interface WishlistItemListProps {
  items: WishlistItem[] | undefined
  isLoading?: boolean
  sectionConfig: { tracker?: string }
  isSelfWishlist?: boolean
}

function WishlistItemList(props: WishlistItemListProps) {
  if (shouldUseDesignSystem()) {
    return <WishlistItemListDS {...props} />
  }
  return <WishlistItemListLegacy {...props} />
}

export default WishlistItemList
